"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TapTransform = void 0;
exports.tap = tap;
var _nodeStream = require("node:stream");
class TapTransform extends _nodeStream.PassThrough {
  constructor(tapFn, options = {}) {
    super({
      objectMode: true,
      ...options
    });
    this.tapFn = tapFn;
  }
  _transform(chunk, _encoding, callback) {
    try {
      this.tapFn(chunk);
      callback();
    } catch (error) {
      callback(error);
    }
  }
}
exports.TapTransform = TapTransform;
function tap(callback) {
  return new TapTransform(callback);
}